import { render, staticRenderFns } from "./AgencyProjectExpertEvaluationList.vue?vue&type=template&id=31347d66&scoped=true&"
import script from "./AgencyProjectExpertEvaluationList.vue?vue&type=script&lang=js&"
export * from "./AgencyProjectExpertEvaluationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31347d66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardTitle})
